import { DashboardActionTypes } from './constants';

export const defaultState = () => ({
  dashboardMounted: false,
});

export const dashboard = (state = defaultState(), action) => {
  switch (action.type) {
    case DashboardActionTypes.SET_DASHBOARD_MOUNTED:
      return {
        ...state,
        dashboardMounted: true,
      };
    case DashboardActionTypes.SET_DASHBOARD_UNMOUNTED:
      return {
        ...state,
        dashboardMounted: false,
      };
    default:
      return state;
  }
};
